import { uniq } from 'lodash';

import {
  ENTITY_PAGE_MAP,
  type ENTITY_TYPES_PER_PAGE,
} from 'hb-react/shared/utils/entitiesContentData/constants';
import { type EntityType } from 'hb-react/shared/utils/entitiesContentData/types';

const isDefined = <T>(value: T | undefined): value is T => value !== undefined;

/**
 * Returns the page identifiers for the given entity types.
 *
 * @param entityTypes - The entity types to get the page identifiers for.
 * @returns The page identifiers for the given entity types.
 */
export const getPageIdentifiersForEntityTypes = (
  entityTypes: Array<EntityType>,
): Array<keyof typeof ENTITY_TYPES_PER_PAGE> =>
  uniq(
    entityTypes
      .map((entityType) => ENTITY_PAGE_MAP[entityType])
      .filter(isDefined),
  );
